import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./ab2cAuthProvider";
import { ALLOWED_DOMAINS_TEXT, AuthLayout } from "./AuthLayout";
import axios from "axios";


export const Login = () => {
  const { instance, inProgress } = useMsal();
  const [isToken, setIsToken] = useState(false);

  const handleLoginPopup = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        redirectUri: "/",
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    let t = async () => {
      const token = await instance.acquireTokenSilent(loginRequest);
      localStorage.setItem("webApiAccessToken", token.accessToken);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token.accessToken}`;
      setIsToken(true);
    };
    if (inProgress != "startup" && instance?.getActiveAccount() && !isToken) {
      t();
    }
  }, [instance, inProgress]);

  return (
    <AuthLayout>
      <h2 className="text-[22px] font-light tracking-[-0.02em] text-[var(--sc-text)] m-0">Zaloguj się</h2>
      <p className="text-[13px] text-[var(--sc-muted)] mt-2 mb-6 leading-relaxed">
        Użyj konta służbowego Scientia ({ALLOWED_DOMAINS_TEXT}).
      </p>
      <button
        onClick={() => handleLoginPopup()}
        className="flex w-full items-center justify-center gap-2 rounded-[var(--sc-radius-md)] bg-[var(--sc-amber)] px-4 py-2.5 text-[14px] font-medium text-[#0F0F0F] border-none cursor-pointer transition-colors hover:bg-[#e09620] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--sc-amber)]"
      >
        Zaloguj się
      </button>
      <p className="text-[11px] text-[var(--sc-muted)] mt-6 mb-0">
        Nie masz konta albo nie pamiętasz hasła? Skontaktuj się z administratorem Scientia Reports.
      </p>
    </AuthLayout>
  );
};

export default Login;
